import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnswerSection from '../common/AnswerSection';
import './AnswersContainer.scss';

class AnswersContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {
    const {
      categories,
      questionableId,
      questionableType,
      fullView,
      csrfToken,
      editMode,
      questionnaireName,
      updateCompletionPercentage,
      suggestedTags,
      updateSuggestedTags,
      showSuggestionModal,
    } = this.props;
    return (
      <div className="answer-container">
        {categories.map((category) => (
          <AnswerSection
            key={category[1]}
            questionCategoryId={category[1]}
            title={category[0]}
            questionableId={questionableId}
            questionableType={questionableType}
            fullView={fullView}
            csrfToken={csrfToken}
            editMode={editMode}
            questionnaireName={questionnaireName}
            updateCompletionPercentage={updateCompletionPercentage}
            suggestedTags={suggestedTags}
            updateSuggestedTags={updateSuggestedTags}
            showSuggestionModal={showSuggestionModal}
          />
        ))}
      </div>
    );
  }
}

AnswersContainer.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  ).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  fullView: PropTypes.bool,
  csrfToken: PropTypes.string,
  editMode: PropTypes.bool,
  questionnaireName: PropTypes.string.isRequired,
  updateCompletionPercentage: PropTypes.func,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string,
};

AnswersContainer.defaultProps = {
  fullView: true,
  csrfToken: '',
  editMode: false,
  updateCompletionPercentage: () => {},
  updateSuggestedTags: () => {},
  suggestedTags: {},
  showSuggestionModal: '',
};

export default AnswersContainer;
